import { ConnectionTypeName } from '../../connections/connection.models';

export function connectionIconUrlByType(connectionType: ConnectionTypeName): string {
  if (!connectionType) {
    return null;
  }
  return `assets/img/vendor/connections/${connectionType}.png`;
}
